import axios from 'src/utils/axios';
import { coz, dizi } from './teklifApi';

export const GRUPLAR = [
  { kod: 'MALZEME', ad: 'Malzeme', excel: 'MALZEME' },
  { kod: 'ISCILIK', ad: 'İşçilik', excel: 'İŞÇİLİK' },
  { kod: 'DIGER', ad: 'Diğer Bedeller', excel: 'DİĞER BEDELLER' }
];

const BASARISIZ = { Basarili: false, Mesaj: 'İşlem sonucu alınamadı.' };

// Yönetici değilse sunucu yalnız kullanıcının servisine ait listeleri döner
export const getFiyatListeleri = async (sadeceAktif = false) => {
  const { data } = await axios.get(`/GetHavcPriceLists/${sadeceAktif}`);
  const c = coz(data, {});
  return {
    yoneticiMi: c.YoneticiMi === true,
    listeler: Array.isArray(c.Listeler) ? c.Listeler : []
  };
};

export const getFiyatListesiKalemleri = async (
  fiyatListesiId,
  sadeceAktif = false
) => {
  const { data } = await axios.get(
    `/GetHavcPriceListItems/${fiyatListesiId}/${sadeceAktif}`
  );
  return dizi(data);
};

export const fiyatListesiKaydet = async ({
  FiyatListesiId = 0,
  Ad,
  Aktif = true,
  KopyaKaynakId = 0
}) => {
  const { data } = await axios.post('/SetHavcPriceList', {
    FiyatListesiId,
    Ad,
    Aktif,
    KopyaKaynakId
  });
  return coz(data, BASARISIZ);
};

export const fiyatListesiKalemleriKaydet = async (fiyatListesiId, kalemler) => {
  const { data } = await axios.post('/SetHavcPriceListItems', {
    FiyatListesiId: fiyatListesiId,
    Kalemler: kalemler.map((k) => ({
      KalemId: k.KalemId || 0,
      Grup: k.Grup,
      Tanim: k.Tanim,
      Adet: Number(k.Adet),
      Birim: k.Birim,
      Fiyat: Number(k.Fiyat),
      ParaBirimi: k.ParaBirimi,
      Aktif: k.Aktif !== false,
      Sira: k.Sira || 0
    }))
  });
  return coz(data, BASARISIZ);
};

/** Servis erişimleri: [{ ServisId, ServisAdi, Gorebilir }]; Gorebilir false = Göremez */
export const getFiyatListesiErisim = async (fiyatListesiId) => {
  const { data } = await axios.get(`/GetHavcPriceListAccess/${fiyatListesiId}`);
  return dizi(data);
};

export const fiyatListesiErisimKaydet = async (fiyatListesiId, erisimler) => {
  const { data } = await axios.post('/SetHavcPriceListAccess', {
    FiyatListesiId: fiyatListesiId,
    Erisimler: erisimler
  });
  return coz(data, BASARISIZ);
};
